import { api } from "./api";
import {
  CREATE_SCHEDULE_CLASS,
  GET_UPCOMING_CLASSES,
  GET_RECORDINGS,
  GET_COURSE_RECOMMENDATION,
} from "../apiEndPoints";

export const classApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    createScheduleClass: builder.mutation({
      query: (payload) => ({
        url: CREATE_SCHEDULE_CLASS,
        method: "POST",
        body: payload,
      }),
    }),
    getUpcomingClasses: builder.query({
      query: ({
        student_id,
        coaching_id,
        coaching_name,
        batch_name,
        subject,
      }) => {
        let URL = `${GET_UPCOMING_CLASSES}?student_id=${student_id}`;

        if (coaching_id) {
          URL += `&coaching_id=${coaching_id}`;
        }

        if (coaching_id) {
          URL += `&coaching_id=${coaching_id}`;
        }
        if (coaching_name) {
          URL += `&coaching_name=${coaching_name}`;
        }
        if (batch_name) {
          URL += `&batch_name=${batch_name}`;
        }
        if (subject) {
          URL += `&subject=${subject}`;
        }

        return {
          url: URL,
          method: "GET",
        };
      },
    }),
    getRecordings: builder.query({
      query: ({ student_id, coaching_id }) => {
        let URL = `${GET_RECORDINGS}?student_id=${student_id}`;
        if (coaching_id) {
          URL += `&coaching_id=${coaching_id}`;
        }
        return {
          url: URL,
          method: "GET",
        };
      },
    }),
    getCourseRecommendation: builder.query({
      query: ({ student_id }) => ({
        url: `${GET_COURSE_RECOMMENDATION}?student_id=${student_id}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateScheduleClassMutation,
  useGetUpcomingClassesQuery,
  useGetRecordingsQuery,
  useGetCourseRecommendationQuery,
} = classApiSlice;
